import React, { useState } from 'react';
import './App.css';
import Stripe from 'stripe';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container'; 

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://aurafare.com/">
        Aurafare Corp.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    borderRadius: '25px',
    background: 'linear-gradient(63deg, rgba(77,190,223,1) 0%, rgba(14,42,81,1) 100%)',
  },
  stripe: {
    height: 50
  },
  stripeBox: {
   backgroundColor: '#DCDCDC',
   borderRadius: '15px'
  },
  comp: {
   height: '200px'
   }
}));

function Setup() {
  const classes = useStyles();
  const [loading, setLoading] = useState('Save and continue');
  const [name, setName] = useState('');
  const [website, setWebsite] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [postal, setPostal] = useState('');
  const [first, setFirst] = useState('');
  const [last, setLast] = useState('');

  function handleClick(e) {
    e.preventDefault();
    setLoading('Loading...')
    createAccount().then(console.log('message.id'));
  }

  // - create account
  function createAccount() { // btok_xxx
    var fd =  new FormData(document.getElementById("account-form"));
    debug('Creating account...');
    return fetch('https://us-central1-onboarding-b9a6e.cloudfunctions.net/app/create-bank', {
    method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },
      body: JSON.stringify({
        name: name,
        city: city,
        state: state,
        postal: postal,
        website: website,
        address: address,
        first: first,
        last: last
      })
    }).then(function(r) {
      return r.json()
    }).then(function(response) {
      debug(JSON.stringify(response, null, 2));
      localStorage.setItem("acct", response.id);
      window.location.replace(response.url);
    });
  }

  function debug(message) {
    var debugMessage = document.getElementById('debug-message');
    console.log('DEBUG: ', message);
    debugMessage.innerText += "\n" + message;
  }
  
  return (
    <div className="App">
      
        <div id="debug-message"></div>

      <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <br/>
        <form className={classes.form} noValidate id="account-form">
         <Grid container spacing={2}>
        
           
            <Grid item xs={12}>
               <img src="Law.gif" className={classes.comp}/>
        <Typography component="h1" variant="h5">
          Compliance
        </Typography>
        <Typography  variant="h6">
          Please tell us about your company. As a marketplace provider the following steps are required in accordance with federal regulations.  
        </Typography>
            </Grid>
       
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="name"
                name="name" 
                variant="outlined"
                required
                fullWidth
                label="First Name"
                onChange={event => setFirst(event.target.value)}
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="Last Name"
                name="last"
                onChange={event => setLast(event.target.value)}
                autoComplete="lastName"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="coname"
                name="name" 
                variant="outlined"
                required
                fullWidth
                label="Company Name"
                onChange={event => setName(event.target.value)}
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="Website"
                name="url"
                onChange={event => setWebsite(event.target.value)}
                autoComplete="website"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="Address"
                name="line1" 
                onChange={event => setAddress(event.target.value)}
                autoComplete="address"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="city"
                name="city" 
                onChange={event => setCity(event.target.value)} 
                variant="outlined"
                required
                fullWidth
                label="City"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="State"
                name="state"
                onChange={event => setState(event.target.value)}
                autoComplete="state"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="Postal Code"
                name="postal_code"
                onChange={event => setPostal(event.target.value)}
                autoComplete="postal_code"
              />
            </Grid>
            
            <Grid item xs={12} >
            <br/>
            <img src="PAY.gif" className={classes.comp}/>
        <Typography component="h1" variant="h5">
          Payments
        </Typography>
        <Typography  variant="h6">
          In order to purchase items and receive payments, we require your primary bank account information. For Beta testing we assume the following payment method is collected.  
        </Typography>
            <br/>
          <Typography variant="body1">
          bank_account: 
          <br/>
        country: 'US',
        <br/>
        currency: 'usd',
        <br/>
        account_holder_name: 'Ramy Guindy',
        <br/>
        account_holder_type: 'individual',
        <br/>
        routing_number: '110000000',
        <br/>
        account_number: '000123456789',
          </Typography>
            <br/>
              <FormControlLabel className={classes.stripeBox}
                control={<img src='Stripe wordmark - slate_lg.png' className={classes.stripe} />}
                label="We use Stripe to make sure you get paid on time and to keep your personal bank and details secure. Click Save and continue to set up your business profile on Stripe."
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            id="account-button" 
            onClick={handleClick}
          >
           {loading}
          </Button>
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
    </div>
  );
}

export default Setup;